import React from "react";
import { Container, Row } from "react-bootstrap";
import { withTranslation } from 'react-i18next';
import CategoryLoading from "../PlaceHolder/CategoryLoading";
import { queryKeys } from "../../services/react-query/queryKeys";
import { listPopularProducts } from "../../network/product";
import { useQuery } from "@tanstack/react-query";
import ProductCard from "../Comman/ProductCard";

const AllPopularProduct = ({ t, i18n }) => {
  const { data: productData, isLoading, error } = useQuery({
    queryKey: [queryKeys.listPopularProducts, i18n],
    queryFn: listPopularProducts,
    enabled: !!i18n
  });

  if (isLoading) {
    return <CategoryLoading />;
  }

  if (error) {
    return <div>{t('SomethingWentWrong')}</div>;
  }

  return (
    <Container className="pt-5 pb-5">
      <p className={"section-header"}>{t('Product')}</p>
      <Row>
        {productData.data.map((item, i) => (
          <ProductCard key={i} product={item} />
        ))}
      </Row>
    </Container>
  );
};

export default withTranslation()(AllPopularProduct);
